{"slots":["slots","video_slots"],"table":["table","table_games","casino","casino_games"],"lottery":["lottery"],"bingo":["bingo"]}